<template>
  <main class="post">

    <div class="blog">


     <div class="loading" :style="{ minHeight: '46.18rem' }" v-if="!loaded">
        <loading-spinner :style="{ position: 'static' }"></loading-spinner>
      </div>

      <transition-group class="blog-grid" name="list" v-if="loaded">
        <BlogItem class="blog-item" v-for="post in posts" :key="post.id" :post="post" />
      </transition-group>

      <Pagination />

    </div>

    <Footer />
  </main>
</template>

<script>
import BlogItem from '../../components/Blog/BlogItem.vue';
import Footer from '../../components/Footer/Footer.vue';

export default {
  name: 'blog', 

  components: { 
    BlogItem,
    Footer
  },

  data() {
    return {
      loaded: false, 
      timer: null,
      post: null,
      currentPage: 1
    }
  },

  mounted() {
    this.getPage();
  },
  
  computed: {
    posts() {
      return this.$store.state.posts;
    },
    totalPages() {
      return this.$store.state.totalPages;
    },
    currentPage() {
      return this.$store.state.currentPage;
    }
  },

  methods: {
    getPosts() {

      const posts_per_page = this.$wpoptions.posts_per_page;
      this.loaded = false;

      this.$store.dispatch('getPosts', { per_page: posts_per_page, page: currentPage }).then(res => {

        this.$store.state.totalPages = Array.from({length: res.headers['x-wp-totalpages']}, (value, key) => ++key); 
        this.$store.commit('setPosts', res.data);
        
      })

      this.timer = setTimeout(() => this.loaded = true, 1000);

    },

    getPage() {
      this.startAnimation = false;
      this.loaded = false;
      const slug = this.$route.name; // TILLFÄLLIG LÖSNING. 
      // TODO - Hämta blog data med hjälp av routing från Page.
      this.$store.dispatch('getPage', slug).then((data) => {
        if (!data) {
          return this.$router.push('/404');
        }


        this.$store.commit('setTitle', data.title.rendered);
        this.$store.commit('setCurrent', data.id);
        const slide = {
          ...data,
          video: data.acf.video,
          img: data.featured_image_url,
          title: data.title.rendered,
          url: data.link,
          excerpt: data.excerpt.rendered,
          color: data.acf.color_theme || 'white',
          themeColor: data.acf.theme_color || 'white',
          buttonClass: data.acf.button_style,
        };

          this.$store.commit('setHeroAndNavigate', {
            slide,
          });

        this.post = data;
        this.getPosts();
    })
    
  }

  },

  destroyed() {
    clearTimeout(this.timer);
    this.$store.state.currentPage = 1;
  },

  watch: {
      '$route'(to, from) {
        this.getPosts();
      },
      currentPage: function() {
        this.getPosts();
      }
    }

}

</script>

<style lang="scss">
@import "../../scss/settings";

.list-move {
  transition: all .6s;
}
.blog-grid {
  transition: all .6s ease-in-out;
}
.list-enter-active,
.list-leave-active {
  transition: all .6s;
  transform: scale(.95);
}
.list-leave-active {
  position: absolute;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateX(75px) scale(.88);
}


</style>